import { dtLabelSanitizer, formattedNumber } from '~/src/Lib/Utils'

import { interruptionFormatterUtil } from './InterruptionFormatter/utils'

export { default as IconFormatter } from './IconFormatter'

export const showLocationInBody = props => {
  const { annotation: { data }, fields, room, zone } = props
  return !!data?.zone && !(room || zone) && !fields?.includes?.('location')
}

const formatterUtils = {
  default: props => {
    const { annotation } = props
    const { message, subject } = annotation

    return {
      title: subject,
      body: message,
    }
  },
  defaultWithDataType: props => {
    const { annotation } = props
    const { data, subject } = annotation

    return {
      title: dtLabelSanitizer(subject),
      body: `reading: ${data?.value} ${'\u2014'} threshold: ${data?.threshold}`,
      location: showLocationInBody(props) ? `${data?.zone}: ` : '',
    }
  },
  BATTERY_LOW: props => {
    const { annotation, entities } = props
    const { devices } = entities
    const { data, device: deviceId, message } = annotation
    const { [deviceId]: device } = devices

    const serialNumber = data?.serialNumber ?? device?.serialNumber
    const deviceName = data?.deviceName ?? device?.deviceName

    return {
      title: `
      ${deviceName ? `${deviceName} ` : ''}
      ${deviceName && serialNumber && deviceName !== serialNumber ? `(${serialNumber}) ` : ''}
      ${(!deviceName && serialNumber) ? `${serialNumber} ` : ''}
      low battery
      `,
      body: data?.battery ? `Battery level: ${formattedNumber(data.battery, 1)}%` : message,
    }
  },
  LIGHT_SCHEDULE: props => {
    const { annotation } = props
    const { data } = annotation
    const { actualOnOrOff, expectedOnOrOff, time } = data

    return {
      title: `Lights still ${actualOnOrOff}`,
      body: `Lights were scheduled to turn ${expectedOnOrOff} at ${time}`,
    }
  },
  DEVICE_UNPLUGGED: interruptionFormatterUtil,
  DEVICE_DISCONNECTED: interruptionFormatterUtil,
  GATEWAY_DISCONNECTED: interruptionFormatterUtil,
  PUCK_DISCONNECTED: interruptionFormatterUtil,
}

export const formatNotification = dataToFormat => {
  const { annotation } = dataToFormat

  if (!annotation) {
    return null
  }

  const { dataTypeKey, key } = annotation

  let { [key]: formatterUtil } = formatterUtils

  if (!formatterUtil) {
    formatterUtil = dataTypeKey
      ? formatterUtils.defaultWithDataType
      : formatterUtils.default
  }

  return formatterUtil(dataToFormat)
}
